import { takeUntil } from 'rxjs/operators';
import { UnsubscribeOnDestroy } from 'src/app/_helpers/unsubscribe-on-destroy';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UntypedFormBuilder, FormGroup, Validators, FormControl, ValidatorFn, ValidationErrors } from '@angular/forms';
import { first } from 'rxjs/operators';
import { AuthService } from '../_services/auth.service';
import { MustMatch } from '../_helpers/must-match.validator';
import { ServicioGeneral } from '../_services/servicio-general.service';
import { HttpResponse } from '@angular/common/http';
import { NotificationService } from '../_services/notification.service';
import { NotificationI18nService } from '../core/util/notification-i18n.service';

enum TokenStatus {
  Validating,
  Valid,
  Invalid
}

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent extends UnsubscribeOnDestroy implements OnInit {
  form: FormGroup = new FormGroup({
    email: new FormControl("", [Validators.required, Validators.email]),
    newPassword: new FormControl("", [Validators.required]),
    newPasswordConfirmar: new FormControl("", [Validators.required]),
  }
  );

  TokenStatus = TokenStatus;
  tokenStatus = TokenStatus.Validating;
  isSuccessful = false;
  loading = false;
  identificador: string = '';
  constructor(
    private formBuilder: UntypedFormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private serviciogeneral: ServicioGeneral,
    private _notificationI18n: NotificationI18nService

  ) {
    super();
  }

  ngOnInit() {
    this.form.addValidators( this.passwordMatchValidator('newPassword', 'newPasswordConfirmar'))

    const token = this.route.snapshot.queryParams['token'];

    // remove token from url to prevent http referer leakage
    this.router.navigate([], { relativeTo: this.route, replaceUrl: true });

    this.obtenerIdentificador();

  }

  obtenerIdentificador() {
    this.route.params
      
        .pipe(takeUntil(this.destroy$))
        .subscribe(params => {
        this.identificador = params['identificador'];
      }
      );
  }
  passwordMatchValidator(controlName: string, matchingControlName: string) :ValidatorFn {
    return (formGroup: FormGroup): ValidationErrors => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ passwordMatchValidator: true });
      } else {
        matchingControl.setErrors(null);
      }
      return;
    };
    
  }
  get f() { return this.form.controls; }

  preSubmit():any{
    if(!this.form.controls['email']?.touched)this.form.controls['email']?.markAsTouched();
    if(!this.form.controls['newPassword']?.touched)this.form.controls['newPassword']?.markAsTouched();
    if(!this.form.controls['newPasswordConfirmar']?.touched)this.form.controls['emanewPasswordConfirmaril']?.markAsTouched();
    return true;
  }

  onSubmit(): any {
    const email = this.form.controls['email']?.value
    const newPassword = this.form.controls['newPassword']?.value;

    this.loading = true;
    this.serviciogeneral.resetPassword(this.identificador, email, newPassword)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
      next: data => {
        this.isSuccessful = true;
        this._notificationI18n.success('NOTIFICATION.MESSAGE.CONTRASENA_RESETEADA_ACCEDA_CON_LOS_NUEVOS_DATOS_DE_ACCESO', 5000);
        this.router.navigate(['/login']);
      },
      error: err => { 
        this.loading = false;
        if(err && err.error?.responseCode == 625){
          this._notificationI18n.error('NOTIFICATION.MESSAGE.EL_MAIL_INDICADO_NO_ES_VALIDO', 5000);
        }
        else{
          this._notificationI18n.errorDynamic(err.error.responseError, 5000);
        }
      }
    });



  }

}
